(
    function (skyward, $)
    {
        skyward.journalentryselector = skyward.journalentryselector || {};

        skyward.journalentryselector.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestWaitingMessageSubject');
            var waitingMessageContent = $('#editJournalEntryRequest_JournalEntryRequestWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} is waiting for your approval';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} is waiting for your approval at {TaskInstance.JournalEntryApproval.LevelDescription}.';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        }

        skyward.journalentryselector.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestApprovedMessageSubject');
            var approvedMessageContent = $('#editJournalEntryRequest_JournalEntryRequestApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} has been approved';
            var defaultApprovedMessageContent = '{JournalEntry.UserCreatedBy.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} has been approved at {TaskInstance.JournalEntryApproval.LevelDescription}.';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        }

        skyward.journalentryselector.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestDeniedMessageSubject');
            var deniedMessageContent = $('#editJournalEntryRequest_JournalEntryRequestDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} has been denied';
            var defaultDeniedMessageContent = '{JournalEntry.UserCreatedBy.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} has been denied at {TaskInstance.JournalEntryApproval.LevelDescription}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);